import React from 'react';
import {
  ShoppingBag,
  UtensilsCrossed,
  Stethoscope,
  GraduationCap,
  Building2,
} from 'lucide-react';
import { useSite } from '../context/SiteContext';

const iconMap = { ShoppingBag, UtensilsCrossed, Stethoscope, GraduationCap, Building2 };

const Industries = () => {
  const { industries = [] } = useSite();
  return (
    <section id="industries" className="section pt-0">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="rounded-3xl border border-white/8 bg-white/[0.02] p-8 md:p-12 relative overflow-hidden">
          <div
            aria-hidden
            className="absolute inset-0 -z-0 opacity-40"
            style={{
              background:
                'radial-gradient(ellipse at 100% 0%, rgba(148,179,61,0.12), transparent 55%), radial-gradient(ellipse at 0% 100%, rgba(229,0,109,0.12), transparent 55%)',
            }}
          />
          <div className="relative">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
              <div>
                <p className="text-xs uppercase tracking-[0.24em] text-brand-green-light">
                  Industries we power
                </p>
                <h2 className="mt-3 text-3xl md:text-4xl font-bold text-white">
                  Tailored for every sector.
                </h2>
              </div>
              <p className="text-slate-400 max-w-md">
                From retail floors to hospital corridors — our solutions adapt to your
                environment and scale with your growth.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {industries.map((ind) => {
                const Icon = iconMap[ind.icon] || Building2;
                return (
                  <div
                    key={ind.name}
                    className="rounded-2xl p-5 border border-white/8 bg-[#0a0d17] card-lift"
                  >
                    <div className="h-10 w-10 rounded-lg bg-brand-green/10 border border-brand-green/30 flex items-center justify-center">
                      <Icon className="h-5 w-5 text-brand-green-light" />
                    </div>
                    <h3 className="mt-4 text-white font-semibold">{ind.name}</h3>
                    <p className="mt-2 text-xs text-slate-400 leading-relaxed">{ind.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
